<template>
  <div>
    <!-- CARD EDIT COMPONENT -->
    <!-- Analytic component -->
    <div
      v-if="modeEdit && dataMaster.name === 'analytic'"
    >
      <j-analytic-setup
        :data-master="dataMaster"
        :mode-create="modeCreate"
        :mode-edit="modeEdit"
        :data-edit="dataEdit"
        @close-field="closeMode"
      />
    </div>

    <!-- Analytic2 component -->
    <div
      v-if="modeEdit && dataMaster.name === 'analytic_v2'"
    >
      <j-analytic2-setup
        :data-master="dataMaster"
        :mode-create="modeCreate"
        :mode-edit="modeEdit"
        :data-edit="dataEdit"
        @close-field="closeMode"
      />
    </div>

    <!-- Attendance component -->
    <div
      v-if="modeEdit && dataMaster.name === 'attendance'"
    >
      <j-attendance-setup
        :data-master="dataMaster"
        :mode-create="modeCreate"
        :mode-edit="modeEdit"
        :data-edit="dataEdit"
        @close-field="closeMode"
      />
    </div>

    <!-- Channel component -->
    <div
      v-if="modeEdit && dataMaster.name === 'channel'"
    >
      <j-channel-setup
        :data-master="dataMaster"
        :mode-create="modeCreate"
        :mode-edit="modeEdit"
        :data-edit="dataEdit"
        @close-field="closeMode"
      />
    </div>

    <!-- Discussion component -->
    <div
      v-if="modeEdit && dataMaster.name === 'discussion'"
    >
      <j-discussion-setup
        :data-master="dataMaster"
        :mode-create="modeCreate"
        :mode-edit="modeEdit"
        :data-edit="dataEdit"
        @close-field="closeMode"
      />
    </div>

    <!-- HTML component -->
    <div
      v-if="modeEdit && dataMaster.name === 'html'"
    >
      <j-html-setup
        :data-master="dataMaster"
        :mode-create="modeCreate"
        :mode-edit="modeEdit"
        :data-edit="dataEdit"
        @close-field="closeMode"
      />
    </div>

    <!-- Timesheet component -->
    <div
      v-if="modeEdit && dataMaster.name === 'timesheet'"
    >
      <j-timesheet-setup
        :data-master="dataMaster"
        :mode-create="modeCreate"
        :mode-edit="modeEdit"
        :data-edit="dataEdit"
        @close-field="closeMode"
      />
    </div>

    <!-- Register Peruri component -->
    <div
      v-if="modeEdit && dataMaster.name === 'digital_signature_register_peruri'"
    >
      <j-register-peruri-setup
        :data-master="dataMaster"
        :mode-create="modeCreate"
        :mode-edit="modeEdit"
        :data-edit="dataEdit"
        @close-field="closeMode"
      />
    </div>

    <!-- Sign document component -->
    <div
      v-if="modeEdit && dataMaster.name === 'digital_signature_sign'"
    >
      <j-sign-document-setup
        :data-master="dataMaster"
        :mode-create="modeCreate"
        :mode-edit="modeEdit"
        :data-edit="dataEdit"
        @close-field="closeMode"
      />
    </div>

    <!-- Status document component -->
    <div
      v-if="modeEdit && dataMaster.name === 'digital_signature_document'"
    >
      <j-status-document-setup
        :data-master="dataMaster"
        :mode-create="modeCreate"
        :mode-edit="modeEdit"
        :data-edit="dataEdit"
        @close-field="closeMode"
      />
    </div>

    <!-- Upload document component -->
    <div
      v-if="modeEdit && dataMaster.name === 'digital_signature_upload'"
    >
      <j-upload-document-setup
        :data-master="dataMaster"
        :mode-create="modeCreate"
        :mode-edit="modeEdit"
        :data-edit="dataEdit"
        @close-field="closeMode"
      />
    </div>

    <!-- Create record component -->
    <div
      v-if="modeEdit && dataMaster.name === 'create_record'"
    >
      <j-create-record-setup
        :data-master="dataMaster"
        :mode-create="modeCreate"
        :mode-edit="modeEdit"
        :data-edit="dataEdit"
        @close-field="closeMode"
      />
    </div>

    <!-- Todo task component -->
    <div
      v-if="modeEdit && dataMaster.name === 'todo_task'"
    >
      <j-todo-setup
        :data-master="dataMaster"
        :mode-create="modeCreate"
        :mode-edit="modeEdit"
        :data-edit="dataEdit"
        @close-field="closeMode"
      />
    </div>

    <!-- Quota leave component -->
    <b-card
      v-if="modeEdit && dataMaster.name === 'quota_leave'"
    >
      <j-quota-leave-setup
        :data-master="dataMaster"
        :mode-create="modeCreate"
        :mode-edit="modeEdit"
        :data-edit="dataEdit"
        @close-field="closeMode"
      />
    </b-card>

    <!-- Quota leave component -->
    <b-card
      v-if="modeEdit && dataMaster.name === 'leave_all_employee'"
    >
      <j-leave-all-employee-setup
        :data-master="dataMaster"
        :mode-create="modeCreate"
        :mode-edit="modeEdit"
        :data-edit="dataEdit"
        @close-field="closeMode"
      />
    </b-card>

    <!-- Experience Manager component -->
    <div
      v-if="modeEdit && dataMaster.name === 'experience_manager'"
    >
      <j-experience-manager-setup
        :data-master="dataMaster"
        :mode-create="modeCreate"
        :mode-edit="modeEdit"
        :data-edit="dataEdit"
        @close-field="closeMode"
      />
    </div>

    <!-- Embed Url component -->
    <div
      v-if="modeEdit && dataMaster.name === 'embed_url'">
      <j-embed-url-setup
        :data-master="dataMaster"
        :mode-create="modeCreate"
        :mode-edit="modeEdit"
        :data-edit="dataEdit"
        @close-field="closeMode"
      />
    </div>

    <!-- QR Code Scanner component -->
    <div
      v-if="modeEdit && dataMaster.name === 'qrcode_scanner'">
      <jQRCodeSetup
        :data-master="dataMaster"
        :mode-create="modeCreate"
        :mode-edit="modeEdit"
        :data-edit="dataEdit"
        @close-field="closeMode"
      />
    </div>

    <!-- Shortcut Page component -->
    <div
      v-if="modeEdit && dataMaster.name === 'shortcut_page'">
      <j-shortcut-page-setup
        :data-master="dataMaster"
        :mode-create="modeCreate"
        :mode-edit="modeEdit"
        :data-edit="dataEdit"
        @close-field="closeMode"
      />
    </div>
  </div>
</template>


<script>
/* eslint-disable max-len */
import jAnalyticSetup from '@/views/widget/widget-component/jAnalyticSetup';
import jAnalytic2Setup from '@/views/widget/widget-component/jAnalytic2Setup';
import jAttendanceSetup from '@/views/widget/widget-component/jAttendanceSetup';
import jChannelSetup from '@/views/widget/widget-component/jChannelSetup';
import jDiscussionSetup from '@/views/widget/widget-component/jDiscussionSetup';
import jHtmlSetup from '@/views/widget/widget-component/jHtmlSetup';
import jTimesheetSetup from '@/views/widget/widget-component/jTimesheetSetup';
import jRegisterPeruriSetup from '@/views/widget/widget-component/jRegisterPeruriSetup';
import jSignDocumentSetup from '@/views/widget/widget-component/jSignDocumentSetup';
import jStatusDocumentSetup from '@/views/widget/widget-component/jStatusDocumentSetup';
import jUploadDocumentSetup from '@/views/widget/widget-component/jUploadDocumentSetup';
import jCreateRecordSetup from '@/views/widget/widget-component/jCreateRecordSetup';
import jTodoSetup from '@/views/widget/widget-component/jTodoSetup';
import jQuotaLeaveSetup from '@/views/widget/widget-component/jQuotaLeaveSetup';
import jLeaveAllEmployeeSetup from '@/views/widget/widget-component/jLeaveAllEmployeeSetup';
import jExperienceManagerSetup from '@/views/widget/widget-component/jExperienceManagerSetup';
import jEmbedUrlSetup from '@/views/widget/widget-component/jEmbedUrlSetup';
import jQRCodeSetup from '@/views/widget/widget-component/jQRCodeSetup';
import jShortcutPageSetup from '@/views/widget/widget-component/jShortcutPageSetup';

export default {
  components: {
    jAnalyticSetup,
    jAnalytic2Setup,
    jAttendanceSetup,
    jChannelSetup,
    jDiscussionSetup,
    jHtmlSetup,
    jTimesheetSetup,
    jRegisterPeruriSetup,
    jSignDocumentSetup,
    jStatusDocumentSetup,
    jUploadDocumentSetup,
    jCreateRecordSetup,
    jTodoSetup,
    jQuotaLeaveSetup,
    jLeaveAllEmployeeSetup,
    jExperienceManagerSetup,
    jEmbedUrlSetup,
    jQRCodeSetup,
    jShortcutPageSetup,
  },
  props: {
    // eslint-disable-next-line vue/require-default-prop
    dataMaster: [Object, null],
    modeCreate: {
      type: Boolean,
      default: false,
      required: true,
    },
    modeEdit: {
      type: Boolean,
      default: false,
      required: true,
    },
    // eslint-disable-next-line vue/require-default-prop
    dataEdit: [Object, null],
  },
  methods: {
    closeMode() {
      this.$emit('close-field');
    },
  },
};

</script>



// WEBPACK FOOTER //
// src/views/widget/jWidgetComponentEdit.vue